import { QIcon_eye, QIcon_eye_closed, QIcon_pause_circle, QIcon_volumne } from '@repo/icons/index'
import { useContext, useEffect, useRef, useState } from 'react'
import { useConversationSetting } from '../../../../modules/apis/student/conversation'
import { useCustomerType } from '../../../../modules/apis/student/products'
import { useIsOkToUse } from '../../../../modules/hooks/useAppVersionStatus'
import { n_ai_speaking, n_ai_tutor, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { SoundContext, SoundProvider } from '../../../common/audio/play/Audio'
import Record from '../../../common/audio/record/Record'
import { ActivityScreen, KeyboardModeBtn, KeyboardToolbar, Nudge, Word, judgeAnswer } from '../Common'
import RecordWrapper from './RecordWrapper'

type RoleplayChat = {
  by: 'ai' | 'user' | 'context'
  content: string | Word[]
  content_kr: string
  content_ja: string
  // translated: string
  audio_url: string | Blob
  wordCount?: number
}
type RoleplayActivityProps = {
  roleplay: RoleplayChat[]
  done: boolean
  setDone: (done: boolean) => void
  nextActivity: () => void
  userRole: string
  aiRole: string
  addFail: () => void
  retry?: boolean
  idx?: any
}

const scrollToElement = (el: HTMLDivElement) => {
  setTimeout(() => {
    if (!el) return
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, 100)
}

const UserChatContent = ({ item, showKeywords, isKeyboardMode, onChangeValue, typedValue, inputRef }) => {
  const [isFocused, setIsFocused] = useState(false)
  const spanRef = useRef(null)
  const [inputWidth, setInputWidth] = useState(0)

  const onChangeTyping = (w: string) => {
    onChangeValue(w?.toLowerCase())
  }

  useEffect(() => {
    if (spanRef.current) {
      setInputWidth(spanRef.current.offsetWidth)
    }
  }, [item])

  return (
    <>
      {item.keyword ? (
        showKeywords ? (
          <span
            className={`bg-white rounded-lg border-solid border-gray-200 border-[1.5px] px-[8px] py-[2px] ${
              item.correct === true ? 'text-purple-500' : item.correct === false ? 'text-gray-700' : ''
            } ${item.ns ? 'mr-[4px]' : ''}`}
          >
            {item.word}
          </span>
        ) : (
          <span
            className={`bg-white rounded-lg border-solid border-gray-200 border-[1.5px] px-[8px] py-[2px] ${
              item.correct === true ? 'text-purple-500' : item.correct === false ? 'text-gray-700' : ''
            } ${item.ns ? 'mr-[4px]' : ''}  ${isFocused && isKeyboardMode ? 'border-gray-600' : ''} ${
              isKeyboardMode && 'text-purple-500'
            }`}
          >
            <span ref={spanRef} className={`absolute opacity-0 whitespace-pre Title1-20Bd pointer-events-none`}>
              {item.word}
            </span>
            <input
              type="text"
              ref={inputRef}
              value={typedValue}
              onChange={(e) => onChangeTyping(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              disabled={!isKeyboardMode}
              style={{
                all: 'unset',
                border: 'none',
                outline: 'none',
                width: inputWidth ? `${inputWidth + 4}px` : 'auto',
                background: !isKeyboardMode ? 'white' : 'none',
                opacity: !isKeyboardMode ? 0 : 1,
                whiteSpace: 'nowrap',
              }}
            />
          </span>
        )
      ) : (
        <span
          className={`${item.correct === true ? 'text-purple-500' : item.correct === false ? 'text-gray-700' : ''} ${
            item.ns ? 'mr-[4px]' : ''
          }`}
        >
          {item.word}
        </span>
      )}
    </>
  )
}

const renderContent = (
  content: string | Word[],
  showKeywords = true,
  active = showKeywords,
  isKeyboardMode = false,
  typedAnswers = null,
  setTypedAnswers = null,
  inputRefs = null
) => {
  const onChangeValue = (index: number, val: string) => {
    setTypedAnswers((prev) => ({ ...prev, [index]: val }))
  }

  if (Array.isArray(content)) {
    return (
      <div
        className={`flex flex-row gap-y-[4px] items-center justify-start flex-wrap content-center self-stretch shrink-0 relative ${
          active ? 'text-gray-700' : 'text-gray-400'
        } text-left Title2-18Bd align-middle`}
      >
        {content.map((item, index) => (
          <UserChatContent
            key={`user-chat-content-${index}`}
            item={item}
            isKeyboardMode={isKeyboardMode}
            showKeywords={showKeywords}
            onChangeValue={(val: string) => onChangeValue(index, val)}
            typedValue={typedAnswers?.[index] || ''}
            inputRef={(el: HTMLInputElement) => (inputRefs.current[index] = el)}
          />
        ))}
      </div>
    )
  } else {
    return <div className="text-gray-700 text-left Title2-18Bd relative self-stretch">{content}</div>
  }
}

// const AIChatOld = ({ content, content_kr, content_ja, audio_url, aiRole, currPlay, isRecording }) => {
//   const [playing, setPlaying] = useState(false)
//   const { currentUser } = useCurrentUser()
//   const { locale } = useTranslation()
//   const { data: customerType } = useCustomerType()

//   let isMulticampus = customerType?.isMulticampus

//   const playAudio = () => {
//     if (isRecording) return
//     if (!audio_url) return
//     setPlaying(true)

//     if (isMulticampus) {
//       sound.stop()
//       sound.play([audio_url]).then(() => setPlaying(false))
//     } else {
//       window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'playAudio', url: audio_url }))
//     }
//   }

//   const stopAudio = () => {
//     setPlaying(false)

//     if (isMulticampus) {
//       sound.stop()
//     } else {
//       window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopAudio' }))
//     }
//   }

//   const sound = useContext(SoundContext)
//   return (
//     <div className="bg-white rounded-xl border-solid border-gray-200 border p-[12px] flex flex-col gap-[8px] items-start justify-start flex-1 relative mr-[40px]">
//       <div className="text-gray-500 text-left Body2-14Md relative self-stretch">{aiRole}</div>
//       {renderContent(content)}
//       {locale === 'ko' && <div className="text-gray-500 text-left Body2-14Md relative self-stretch">{content_kr}</div>}
//       {locale === 'ja' && <div className="text-gray-500 text-left Body2-14Md relative self-stretch">{content_ja}</div>}
//       <div className="flex flex-col gap-[4px] items-start justify-start self-stretch shrink-0 relative">
//         <div className="bg-gray-200 self-stretch shrink-0 h-[1px] relative"></div>
//       </div>
//       <div className="flex flex-row items-center justify-between self-stretch shrink-0 relative">
//         <div className="flex flex-row gap-[6px] items-start justify-start shrink-0 relative">
//           {playing || currPlay ? (
//             <QIcon_pause_circle width={20} height={20} onClick={stopAudio} />
//           ) : (
//             <QIcon_volumne width={20} height={20} onClick={playAudio} />
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

const AIChat = ({ content, content_kr, content_ja, audio_url, aiRole, currPlay, playing, onPlay, onStop }) => {
  // const [playing, setPlaying] = useState(false)
  // const { currentUser } = useCurrentUser()
  const { locale } = useTranslation()
  // const { data: customerType } = useCustomerType()

  // let isMulticampus = customerType?.isMulticampus

  // const playAudio = () => {
  //   if (isRecording) return
  //   if (!audio_url) return
  //   setPlaying(true)

  //   if (isMulticampus) {
  //     sound.stop()
  //     sound.play([audio_url]).then(() => setPlaying(false))
  //   } else {
  //     // alert('??')
  //     window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'playAudio', url: audio_url }))
  //   }
  // }

  // const stopAudio = () => {
  //   setPlaying(false)

  //   if (isMulticampus) {
  //     sound.stop()
  //   } else {
  //     window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopAudio' }))
  //   }
  // }

  // const sound = useContext(SoundContext)
  return (
    <div className="bg-white rounded-xl border-solid border-gray-200 border p-[12px] flex flex-col gap-[8px] items-start justify-start flex-1 relative mr-[40px]">
      <div className="text-gray-500 text-left Body2-14Md relative self-stretch">{aiRole}</div>
      {renderContent(content)}
      {locale === 'ko' && <div className="text-gray-500 text-left Body2-14Md relative self-stretch">{content_kr}</div>}
      {locale === 'ja' && <div className="text-gray-500 text-left Body2-14Md relative self-stretch">{content_ja}</div>}
      <div className="flex flex-col gap-[4px] items-start justify-start self-stretch shrink-0 relative">
        <div className="bg-gray-200 self-stretch shrink-0 h-[1px] relative"></div>
      </div>
      <div className="flex flex-row items-center justify-between self-stretch shrink-0 relative">
        <div className="flex flex-row gap-[6px] items-start justify-start shrink-0 relative">
          {playing || currPlay ? (
            <QIcon_pause_circle width={20} height={20} onClick={onStop} />
          ) : (
            <QIcon_volumne width={20} height={20} onClick={onPlay} />
          )}
        </div>
      </div>
    </div>
  )
}

const UserChat = ({
  index,
  content,
  audio_url,
  content_kr,
  content_ja,
  userRole,
  openKeywords,
  isKeyboardMode,
  typedAnswers,
  setTypedAnswers,
}) => {
  const [showKeywords, setShowKeywords] = useState(false)
  const sound = useContext(SoundContext)
  const [playing, setPlaying] = useState(false)
  // const { currentUser } = useCurrentUser()
  const { locale } = useTranslation()

  const inputRefs = useRef<{ [key: number]: HTMLInputElement | null }>({})

  const isOkToUse = useIsOkToUse()

  const playAudio = () => {
    if (isOkToUse) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'playLastRecording' }))
    } else {
      sound.play([audio_url]).then(() => setPlaying(false))
      setPlaying(true)
    }
  }

  const stopAudio = () => {
    sound.stop()
    setPlaying(false)
  }

  useEffect(() => {
    if (isKeyboardMode && Array.isArray(content)) {
      const firstHiddenIndex = content?.findIndex((w: Word) => w.keyword)
      if (firstHiddenIndex >= 0) {
        inputRefs.current[firstHiddenIndex]?.focus()
      }
    }
  }, [isKeyboardMode, content])

  return (
    <div className="bg-gray-100 rounded-xl border-solid border-gray-200 border p-[12px] flex flex-col gap-[8px] items-end justify-start self-stretch shrink-0 relative ml-[40px]">
      <div className="text-gray-500 text-left text-[14px] leading-[20px] font-medium relative self-stretch">
        {userRole}
      </div>

      <div className="flex flex-col gap-[8px] items-start justify-start self-stretch shrink-0 relative">
        {renderContent(
          content,
          showKeywords || openKeywords,
          openKeywords,
          isKeyboardMode,
          typedAnswers,
          setTypedAnswers,
          inputRefs
        )}
      </div>
      {locale === 'ko' && (
        <div className="text-gray-500 text-left text-[14px] leading-[20px] font-medium relative self-stretch">
          {content_kr}
        </div>
      )}
      {locale == 'ja' && (
        <div className="text-gray-500 text-left text-[14px] leading-[20px] font-medium relative self-stretch">
          {content_ja}
        </div>
      )}
      <div className="flex flex-col gap-[4px] items-start justify-start self-stretch shrink-0 relative">
        <div className="bg-gray-200 self-stretch shrink-0 h-[1px] relative"></div>
      </div>
      <div className="flex flex-row items-center justify-between self-stretch shrink-0 relative">
        {audio_url ? (
          playing ? (
            <QIcon_pause_circle width={20} height={20} onClick={stopAudio} />
          ) : (
            <QIcon_volumne width={20} height={20} onClick={playAudio} />
          )
        ) : showKeywords ? (
          <QIcon_eye_closed
            className="shrink-0 w-[20px] h-[20px] relative overflow-visible cursor-pointer"
            onClick={() => setShowKeywords(!showKeywords)}
          />
        ) : (
          <QIcon_eye
            className="shrink-0 w-[20px] h-[20px] relative overflow-visible cursor-pointer"
            onClick={() => setShowKeywords(!showKeywords)}
          />
        )}
      </div>
    </div>
  )
}

const RoleplayActivityInner = ({
  roleplay,
  done,
  setDone,
  nextActivity,
  userRole,
  aiRole,
  addFail,
  retry,
  idx,
}: RoleplayActivityProps) => {
  const { t, locale } = useTranslation()
  const [content, setContent] = useState([] as RoleplayChat[])
  const [openKeywords, setOpenKeywords] = useState(-1)
  const [solved, setSolved] = useState<null | 'done' | 'retry-audio' | 'fail' | 'fail-audio'>(null)
  const messageEnd = useRef<HTMLDivElement>()
  const scrollTo = (e = null) => scrollToElement(e || messageEnd.current)
  const sound = useContext(SoundContext)
  const [currPlay, setCurrPlay] = useState(null)
  const setting = useConversationSetting()
  const [isRecording, setIsRecording] = useState<boolean>(false)

  const [isKeyboardMode, setIsKeyboardMode] = useState(false)
  const [typedAnswers, setTypedAnswers] = useState<Record<number, string>>({})
  const [waitingTranscription, setWaitingTranscription] = useState(false)

  const [playingMap, setPlayingMap] = useState<Record<string, boolean>>({})

  const { data: customerType } = useCustomerType()
  const [wordCount, setWordCount] = useState(0)

  const [recordPayload, setRecordPayload] = useState<any>(null)

  //idle -> starting -> recording -> stopping -> idle
  const [recordingStatus, setRecordingStatus] = useState<any>('idle')
  const [completeText, cancelText] = [n_ai_speaking.ai_session.btn5, n_common.btn_cancel].map((i) => t(i))

  const isOkToUse = useIsOkToUse()

  function generateRandomId(length = 8): string {
    // toString(36) turns numbers into 0–9a–z. slice off the "0." prefix.
    return Math.random()
      .toString(36)
      .substring(2, 2 + length)
  }

  useEffect(() => {
    function handleMessage(event) {
      let data
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        console.error('Invalid message format:', e)
        return
      }

      if (data.type === 'recording') {
        setRecordingStatus('recording')
      }

      if (data.type === 'audioEnded') {
        handleAudioEnded(data.url)
      }

      if (data.type === 'canceled') {
        setRecordingStatus('idle')
      }

      if (data.type === 'recordingResult') {
        setRecordPayload({
          id: generateRandomId(), // e.g. "xk3j5b9q"
          transcription: data.transcription,
          audioBlob: null, // RN 쪽에서 blob 처리한다면 RN 메시지로 받을 수도 있고,
        })

        setRecordingStatus('idle')
      }
    }

    window.addEventListener('message', handleMessage)
    document.addEventListener('message', handleMessage) // iOS 대응

    // 클린업
    return () => {
      window.removeEventListener('message', handleMessage)
      document.removeEventListener('message', handleMessage)
    }
  }, [])

  useEffect(() => {
    if (!recordPayload) return

    // payload가 들어올 때마다 이펙트에서 처리
    handleStopRecording(recordPayload.transcription, recordPayload.audioBlob)

    // (선택) 반복 처리 방지를 위해 페이로드 초기화
    setRecordPayload(null)
  }, [recordPayload])

  function handleAudioEnded(url: string) {
    // setPlayingAudio(false)    setPlaying(false
    // setPlaying(false)

    setPlayingMap((prev) => ({ ...prev, [url]: false }))

    // ② currPlay가 바로 이 URL이면 인덱스 리셋
    setCurrPlay(null)
  }

  useEffect(() => {
    sound.speed = setting.data?.speed || 1
  }, [setting])

  useEffect(() => {
    const li = []

    const playPr: Promise<any> = sound.stop()
    for (let i = 0; i < roleplay.length; i++) {
      const msg = roleplay[i]
      li.push(msg)
      setWordCount(msg.wordCount || 0)
      if (msg.by === 'user') {
        if ((navigator as any).audioSession) (navigator as any).audioSession.type = 'play-and-record'
        break
      } else {
        if ((navigator as any).audioSession) (navigator as any).audioSession.type = 'playback'

        if (!isOkToUse) {
          // alert('1')
          setPlayingMap((prev) => ({ ...prev, [msg.audio_url as string]: true }))
          sound.play([msg.audio_url]).then(() => {
            handleAudioEnded(msg.audio_url as string)
          })
        } else {
          // alert('2')
          setCurrPlay(i)
          requestPlay(msg.audio_url as string)
          // window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'playAudio', url: msg.audio_url }))
        }
      }
    }

    if (!isOkToUse) {
      playPr.then(() => setCurrPlay(null))
    }

    setContent(li)
  }, [roleplay])

  const requestPlay = (url: string) => {
    if (!url) {
      return
    }

    if (url === '') {
      return
    }

    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'playAudio', url }))
      setPlayingMap((prev) => ({ ...prev, [url]: true }))
    } catch (e) {
      // alert('something went wrong?')
    }
  }
  const requestStop = (url: string) => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopAudio', url }))
    setPlayingMap((prev) => ({ ...prev, [url]: false }))
  }

  const handleStopRecording = (text: string, audio: Uint8Array) => {
    const c = content.length - 1

    content[c].content = judgeAnswer(content[c].content as any, text).result

    if (!isOkToUse) {
      content[c].audio_url = new Blob([audio], { type: 'audio/wav' })
    } else {
      //임시
      content[c].audio_url = 'RN'
    }

    for (let i = c + 1; i < roleplay.length; i++) {
      content.push(roleplay[i])
      setWordCount(roleplay[i].wordCount || 0)
      if (roleplay[i].by === 'user') {
        if ((navigator as any).audioSession) (navigator as any).audioSession.type = 'play-and-record'
        break
      } else {
        if ((navigator as any).audioSession) (navigator as any).audioSession.type = 'playback'

        if (!isOkToUse) {
          setPlayingMap((prev) => ({ ...prev, [roleplay[i].audio_url as string]: true }))
          sound.play([roleplay[i].audio_url]).then(() => {
            handleAudioEnded(roleplay[i].audio_url as string)
          })
        } else {
          setCurrPlay(i)
          // alert('when audio generated')
          requestPlay(roleplay[i].audio_url as string)
          // window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'playAudio', url: msg.audio_url }))
        }

        // //여기다 여기.
        // sound.play([roleplay[i].audio_url]).then(() => setCurrPlay(null))
        // setCurrPlay(i)
      }
    }
    setContent(content)
    setOpenKeywords(c)
    scrollTo()
  }

  //뭔가 말하기를 하면,
  const onClickSubmit = () => {
    // typedAnswers
    const c = content.length - 1

    // alert(content[c].content)

    console.log('---🟢')
    console.log(content)

    let sentence = ''
    if (Array.isArray(content[c].content)) {
      ;(content[c].content as Word[]).map((item, index) => {
        if (item.keyword) {
          // Use nullish coalescing operator (??) to fall back to an empty string if typedAnswers[index] is null or undefined
          sentence += (typedAnswers[index] ?? '') + ' '
        } else {
          sentence += item.word + ' '
        }
      })
    }

    console.log(sentence)

    content[c].content = judgeAnswer(content[c].content as any, sentence).result
    content[c].audio_url = roleplay[c].audio_url

    for (let i = c + 1; i < roleplay.length; i++) {
      content.push(roleplay[i])
      setWordCount(roleplay[i].wordCount || 0)
      if (roleplay[i].by === 'user') {
        if ((navigator as any).audioSession) (navigator as any).audioSession.type = 'play-and-record'
        break
      } else {
        if ((navigator as any).audioSession) (navigator as any).audioSession.type = 'playback'

        // this one actually doesn not work
        // alert('s')
        sound.play([roleplay[i].audio_url]).then(() => setCurrPlay(null))

        setCurrPlay(i)
      }
    }
    setContent(content)
    setOpenKeywords(c)
    scrollTo()

    setTypedAnswers({})
    // setIsKeyboardMode(false)
  }

  const onClickKeyboardMode = () => {
    // alert('s')

    onClickSubmit()
    // setIsKeyboardMode(true)
  }

  const onCancel = () => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'cancelRecording' }))
    } catch (e) {
      console.log(e)
    }
    setRecordingStatus('cancelling')
  }

  useEffect(() => {
    // ▶️ when testing to skip
    // setDone(true)
    // setSolved('done')
    // return
    //temporary.

    if (
      (openKeywords === content.length - 1 && content.length) ||
      (roleplay.length === content.length && content[content.length - 1].by !== 'user' && content.length)
    ) {
      setSolved('done')
      setDone(true)
      setTimeout(() => scrollTo(), 300)
    }
  }, [content, openKeywords, roleplay])

  return (
    <ActivityScreen
      title={t(n_ai_tutor.study_activity.six_title)}
      solved={solved}
      nextActivity={nextActivity}
      idx={idx}
    >
      <div className={`flex flex-col gap-[16px] flex-1 w-full overflow-y-auto ${solved && 'pb-[102px]'}`}>
        {content.map(({ by, content, content_kr, content_ja, audio_url }, index) => (
          <div key={index}>
            {by === 'context' && (
              <Nudge className="Body2-16Md" title={t(n_ai_tutor.study_activity.label3)}>
                {locale === 'ko' ? content_kr : locale == 'ja' ? content_ja || content : content}
              </Nudge>
            )}

            {by === 'ai' && (
              <AIChat
                content={content}
                content_kr={content_kr}
                content_ja={content_ja}
                audio_url={audio_url}
                aiRole={aiRole}
                currPlay={index === currPlay}
                playing={!!playingMap[audio_url as string]}
                onPlay={() => requestPlay(audio_url as string)}
                onStop={() => requestStop(audio_url as string)}
              />
            )}

            {by === 'user' && (
              <UserChat
                index={index}
                content={content}
                audio_url={audio_url}
                content_kr={content_kr}
                content_ja={content_ja}
                userRole={userRole}
                openKeywords={openKeywords >= index}
                isKeyboardMode={isKeyboardMode}
                typedAnswers={typedAnswers}
                setTypedAnswers={setTypedAnswers}
              />
            )}
          </div>
        ))}
        {isKeyboardMode && <div className="mb-[72px]" />}
        <div ref={messageEnd} style={{ marginTop: 150 }}></div>
      </div>

      {!solved && !isKeyboardMode && (
        <>
          {isOkToUse ? (
            <div
              className={'opacity-95 flex flex-col bottom-[0px] items-center justify-center pt-[12px] mt-[auto]'}
              style={{
                width: '100%',
                paddingBottom: `calc(12px + env(safe-area-inset-bottom))`,
                height: 148,
                position: 'absolute',
                backgroundColor: 'white',
                left: 0,
              }}
            >
              <RecordWrapper
                recordingStatus={recordingStatus}
                setRecordingStatus={setRecordingStatus}
                onCancel={onCancel}
              />
            </div>
          ) : (
            <Record
              handleStopRecording={handleStopRecording}
              beforeRecord={() => sound.stop()}
              helper={t(n_ai_tutor.study_activity.detail2)}
              onStartRecord={() => {
                setIsRecording(true)
              }}
              onFinishRecord={() => {
                setIsRecording(false)
              }}
              noMargin
              wordCount={wordCount}
            />
          )}
        </>
      )}
      {!isRecording && !waitingTranscription && recordingStatus !== 'recording' && (
        <KeyboardModeBtn onClickKeyboardMode={onClickKeyboardMode} />
      )}
      {isKeyboardMode && recordingStatus !== 'recording' && (
        <KeyboardToolbar setIsKeyboardMode={setIsKeyboardMode} onClickSubmit={onClickSubmit} />
      )}
    </ActivityScreen>
  )
}

export const RoleplayActivity = (props: RoleplayActivityProps) => (
  <SoundProvider key={'roleplay-activity'}>
    <RoleplayActivityInner {...props} />
  </SoundProvider>
)
